import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
import { Globe, Instagram, Send } from "lucide-react";
import type { SocialKey } from "./model";

/* The social marks the collection's links use. lucide has no X or Discord
   mark, so those two are drawn in its stroke style to sit with the rest. */

export function XIcon(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden={true} {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function DiscordIcon(props) {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8.5 7.5c2.3-.7 4.7-.7 7 0M7 17c3.3 1.3 6.7 1.3 10 0" />;
    t1 = <path d="M15.5 7.5 16.5 6c1.6.4 3 1.1 4 2 1.3 2.6 1.8 5.4 1.5 8.4-1.3 1-2.8 1.8-4.4 2.3L16.5 17M8.5 7.5 7.5 6c-1.6.4-3 1.1-4 2-1.3 2.6-1.8 5.4-1.5 8.4 1.3 1 2.8 1.8 4.4 2.3L7.5 17" />;
    t2 = <circle cx="9" cy="12.5" r="1" />;
    t3 = <circle cx="15" cy="12.5" r="1" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden={true} {...props}>{t0}{t1}{t2}{t3}</svg>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
export const SOCIAL_ICON: Record<SocialKey, (props: SVGProps<SVGSVGElement>) => React.ReactElement> = {
  website: p => <Globe {...p} />,
  x: XIcon,
  instagram: p => <Instagram {...p} />,
  telegram: p => <Send {...p} />,
  discord: DiscordIcon
};